import { MapPin, Phone, Mail, ArrowUpRight, Clock } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/motion";
import { ORG, IMAGES } from "../data/site";

const REASONS = [
  { label: "General Enquiry", subject: "General Enquiry" },
  { label: "Donations & Receipts", subject: "Donation" },
  { label: "Partnerships & CSR", subject: "Partnership Enquiry" },
  { label: "Volunteering", subject: "Volunteering" },
];

export default function Contact() {
  return (
    <>
      <PageHeader
        eyebrow="Contact Us"
        title="Let's Talk"
        subtitle="Reach out to visit, volunteer, partner or simply learn more about our work in Thanga, Bishnupur."
        image={IMAGES.health}
      />

      <section className="bg-brand-cream">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24 grid gap-14 lg:grid-cols-12">
          {/* Info */}
          <Reveal className="lg:col-span-6">
            <span className="text-xs uppercase tracking-[0.24em] text-brand-primary">Head Office</span>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl text-brand-ink">We&rsquo;d love to hear from you</h2>
            <div className="mt-8 space-y-5">
              <div className="flex gap-4 rounded-2xl border border-brand-line bg-brand-surface p-5">
                <MapPin className="h-6 w-6 shrink-0 text-brand-primary" />
                <div><p className="font-semibold text-brand-ink">Address</p><p className="mt-1 text-sm text-brand-muted">{ORG.address}</p></div>
              </div>
              <a href={`tel:${ORG.phone}`} data-testid="contact-phone-link" className="flex gap-4 rounded-2xl border border-brand-line bg-brand-surface p-5 hover:border-brand-primary transition-colors">
                <Phone className="h-6 w-6 shrink-0 text-brand-primary" />
                <div><p className="font-semibold text-brand-ink">Phone</p><p className="mt-1 text-sm text-brand-muted">{ORG.phone}</p></div>
              </a>
              <a href={`mailto:${ORG.email}`} data-testid="contact-email-link" className="flex gap-4 rounded-2xl border border-brand-line bg-brand-surface p-5 hover:border-brand-primary transition-colors">
                <Mail className="h-6 w-6 shrink-0 text-brand-primary" />
                <div><p className="font-semibold text-brand-ink">Email</p><p className="mt-1 text-sm text-brand-muted break-all">{ORG.email}</p></div>
              </a>
              <div className="flex gap-4 rounded-2xl border border-brand-line bg-brand-surface p-5">
                <Clock className="h-6 w-6 shrink-0 text-brand-primary" />
                <div><p className="font-semibold text-brand-ink">Office Hours</p><p className="mt-1 text-sm text-brand-muted">Monday – Saturday, 9:00 AM – 5:00 PM (IST)</p></div>
              </div>
            </div>
            <div className="mt-6 overflow-hidden rounded-2xl border border-brand-line">
              <iframe title="Equipping New Life location" src={ORG.mapEmbed} width="100%" height="280" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="contact-map" />
            </div>
          </Reveal>

          {/* Email CTA panel */}
          <Reveal delay={0.1} className="lg:col-span-6">
            <div className="rounded-3xl bg-brand-teal text-brand-cream p-8 sm:p-10 h-full flex flex-col">
              <span className="text-xs uppercase tracking-[0.24em] text-brand-accent">Write to us</span>
              <h3 className="mt-4 font-serif text-3xl sm:text-4xl">Send us an email</h3>
              <p className="mt-5 text-brand-cream/75 leading-relaxed">
                The quickest way to reach us is by email. Pick a topic below and your mail app will open with the subject ready — just add your message and send.
              </p>

              <div className="mt-8 space-y-3">
                {REASONS.map((r) => (
                  <a
                    key={r.subject}
                    href={`mailto:${ORG.email}?subject=${encodeURIComponent(r.subject)}`}
                    data-testid={`contact-reason-${r.subject.toLowerCase().split(" ")[0]}`}
                    className="group flex items-center justify-between gap-4 rounded-2xl border border-brand-cream/15 bg-brand-cream/5 px-5 py-4 hover:bg-brand-cream/10 transition-colors"
                  >
                    <span className="font-medium">{r.label}</span>
                    <ArrowUpRight className="h-5 w-5 text-brand-accent transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                ))}
              </div>

              <a
                href={`mailto:${ORG.email}`}
                data-testid="contact-email-cta"
                className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-brand-accent px-7 py-3.5 font-semibold text-brand-ink hover:bg-[#d95a48] transition-colors"
              >
                <Mail className="h-5 w-5" /> Email {ORG.email}
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
